import moment from "moment";

const common = (() => {
    const formatDate = (date, format = "DD/MM/YYYY") => {
        return moment(date).utc().format(format);
    }
    
    const converToUtcDate = (date) => {
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    }

    const subtractDays = (date, numberOfDays) => {
        let newDate = moment(date).subtract(numberOfDays, "days");
        return new Date(newDate);
    }
    
    
    return { formatDate, converToUtcDate, subtractDays }
})()

export default common;


/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/utils/common.js
 **/